import React, { useState, useRef, useEffect, useContext } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaTractor, FaChevronDown, FaStore, FaWrench } from "react-icons/fa";
import { FiSettings, FiLogOut } from "react-icons/fi";
import "../../../../assets/css/user/general/mynavbar/MyNavbar.css";
import AppContext from "../../../../context/AppContext";

const MyNavbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    isLoggedIn,
    loggedInCustomer,
    baseUrlForFile,
    setIsLoggedIn,
    setLoggedInCustomer,
    setAuthToken,
  } = useContext(AppContext);

  const [showRegisterDropdown, setShowRegisterDropdown] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);

  const dropdownRef = useRef(null);
  const profileDropdownRef = useRef(null);

  // Click outside se dono dropdowns band hon
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowRegisterDropdown(false);
      }
      if (
        profileDropdownRef.current &&
        !profileDropdownRef.current.contains(e.target)
      ) {
        setShowProfileDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    setLoggedInCustomer(null);
    setAuthToken(null);
    setIsLoggedIn(false);
    localStorage.removeItem("authToken");
    localStorage.removeItem("LoggedInCustomer");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userPassword");
    setShowProfileDropdown(false);
    navigate("/");
  };

  return (
    <Navbar expand="lg" className="custom-navbar">
      <Container fluid className="px-4">
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <div className="navbar-logo-circle">
            <FaTractor size={26} />
          </div>
          <div className="brand-text ms-2">
            <div className="nav-brand-name">SMART</div>
            <div className="brand-subtitle">AGRI RENT</div>
          </div>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbar-nav" />

        <Navbar.Collapse id="navbar-nav">
          <Nav className="mx-auto align-items-center">
            <Nav.Link
              as={Link}
              to="/"
              className={`nav-item-custom ${location.pathname === "/" ? "active" : ""}`}
            >
              Home
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/equipments"
              className={`nav-item-custom ${location.pathname === "/rent" ? "active" : ""}`}
            >
              Equipments
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/shop"
              className={`nav-item-custom ${location.pathname === "/shop" ? "active" : ""}`}
            >
              Shop
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/Mechanics"
              className={`nav-item-custom ${location.pathname === "/maintain" ? "active" : ""}`}
            >
              Mechanics
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/aboutus"
              className={`nav-item-custom ${location.pathname === "/aboutus" ? "active" : ""}`}
            >
              About
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/blog"
              className={`nav-item-custom ${location.pathname === "/blog" ? "active" : ""}`}
            >
              Blogs
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/contact"
              className={`nav-item-custom ${location.pathname === "/contact" ? "active" : ""}`}
            >
              Contact
            </Nav.Link>
          </Nav>

          <div className="auth-buttons">
            {isLoggedIn && loggedInCustomer ? (
              // ─── LOGGED IN: Profile Dropdown ───
              <div className="register-dropdown-wrap" ref={profileDropdownRef}>
                <button
                  className="navbar-profile-btn"
                  onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                >
                  {/* Avatar */}
                  <div className="navbar-avatar">
                    {loggedInCustomer.image ? (
                      <img
                        src={`${baseUrlForFile}/${loggedInCustomer.image}`}
                        alt="profile"
                        className="navbar-avatar-img"
                      />
                    ) : (
                      <span className="navbar-avatar-letter">
                        {loggedInCustomer.fullname?.charAt(0).toUpperCase()}
                      </span>
                    )}
                  </div>
                  <span className="navbar-profile-name">
                    {loggedInCustomer.fullname?.split(" ")[0]}
                  </span>
                  <FaChevronDown
                    className={`register-chevron ${showProfileDropdown ? "open" : ""}`}
                  />
                </button>

                {showProfileDropdown && (
                  <div className="register-dropdown-menu navbar-profile-dropdown">
                    {/* Top: Image + Name */}
                    <div className="navbar-dropdown-header">
                      <div className="navbar-dropdown-avatar">
                        {loggedInCustomer.image ? (
                          <img
                            src={`${baseUrlForFile}/${loggedInCustomer.image}`}
                            alt="profile"
                            className="navbar-avatar-img"
                          />
                        ) : (
                          <span className="navbar-avatar-letter">
                            {loggedInCustomer.fullname?.charAt(0).toUpperCase()}
                          </span>
                        )}
                      </div>
                      <div>
                        <div className="navbar-dropdown-name">
                          {loggedInCustomer.fullname}
                        </div>
                        <div className="navbar-dropdown-email">
                          {loggedInCustomer.email}
                        </div>
                      </div>
                    </div>

                    <div className="register-dropdown-divider" />

                    {/* Settings */}
                    <button
                      className="register-dropdown-item"
                      onClick={() => {
                        setShowProfileDropdown(false);
                        navigate("/user/profile");
                      }}
                    >
                      <div className="register-dropdown-icon">
                        <FiSettings />
                      </div>
                      <div className="register-dropdown-text">
                        <span className="register-dropdown-title">
                          Settings
                        </span>
                        <span className="register-dropdown-sub">
                          Manage your profile
                        </span>
                      </div>
                    </button>

                    <div className="register-dropdown-divider" />

                    {/* Logout */}
                    <button
                      className="register-dropdown-item navbar-logout-item"
                      onClick={handleLogout}
                    >
                      <div className="register-dropdown-icon">
                        <FiLogOut />
                      </div>
                      <div className="register-dropdown-text">
                        <span className="register-dropdown-title">Logout</span>
                        <span className="register-dropdown-sub">
                          Sign out of your account
                        </span>
                      </div>
                    </button>
                  </div>
                )}
              </div>
            ) : (
              // ─── NOT LOGGED IN: Original Buttons ───
              <>
                <Link to="/auth" state={{ isLogin: true }}>
                  {" "}
                  {/* pehle false tha, yehi bug tha */}
                  <button className="auth-btn login-btn">Customer</button>
                </Link>

                <div className="register-dropdown-wrap" ref={dropdownRef}>
                  <button
                    className="auth-btn register-btn"
                    onClick={() =>
                      setShowRegisterDropdown(!showRegisterDropdown)
                    }
                  >
                    Service Provider
                    <FaChevronDown
                      className={`register-chevron ${showRegisterDropdown ? "open" : ""}`}
                    />
                  </button>

                  {showRegisterDropdown && (
                    <div className="register-dropdown-menu">
                      <button
                        className="register-dropdown-item"
                        onClick={() => {
                          setShowRegisterDropdown(false);
                          navigate("/rental-admin/login"); // 👈 pehle "/rental-admin/registration" tha
                        }}
                      >
                        <div className="register-dropdown-icon">
                          <FaStore />
                        </div>
                        <div className="register-dropdown-text">
                          <span className="register-dropdown-title">
                            Rental Admin
                          </span>
                          <span className="register-dropdown-sub">
                            List & rent your machinery
                          </span>
                        </div>
                      </button>

                      <div className="register-dropdown-divider" />

                      <button
                        className="register-dropdown-item"
                        onClick={() => {
                          setShowRegisterDropdown(false);
                          navigate("/mechanic-admin/login"); // 👈 pehle "/mechanic-admin/register" tha
                        }}
                      >
                        <div className="register-dropdown-icon">
                          <FaWrench />
                        </div>
                        <div className="register-dropdown-text">
                          <span className="register-dropdown-title">
                            Mechanic Admin
                          </span>
                          <span className="register-dropdown-sub">
                            Offer maintenance services
                          </span>
                        </div>
                      </button>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default MyNavbar;
